module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"general-terms-and-conditions":"Conditions Génerales de Ventes","about-us":"À propos de nous","privacy":"Vie privée & données personnelles"},"en":{"general-terms-and-conditions":"General Terms And Conditions","about-us":"About us","privacy":"Privacy & personal data"}}')
  delete Component.options._Ctor
}
